import { render, staticRenderFns } from "./FormInputFeedBackWrapper.vue?vue&type=template&id=639f70fc"
import script from "./FormInputFeedBackWrapper.vue?vue&type=script&lang=js"
export * from "./FormInputFeedBackWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports